import { fetcher } from "@certn/api";
import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  Text,
  showToast,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  webhookId: string;
  onOpenChange(isOpen: boolean): void;
  onDeleted(): void;
}

export function DeleteWebhookModal({
  isOpen,
  onOpenChange,
  onDeleted,
  webhookId,
}: Props) {
  const { t } = useTranslation();

  const [isDeleting, setIsDeleting] = useState(false);
  const onRevoke = async () => {
    setIsDeleting(true);
    try {
      await fetcher.submit(
        `/api/internal/client-portal/public-api/webhooks/${webhookId}/delete/`
      );
      showToast(t("Webhook revoked"), { type: "success" });
      onDeleted();
      onOpenChange(false);
    } catch (e) {
      console.error("Failed to delete webhook", e);
      showToast(t("Failed to delete webhook"), {
        type: "error",
      });
    }
    setIsDeleting(false);
  };

  return (
    <Modal
      testID="delete-webhook-modal"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog>
        <DialogHeader onClose={() => onOpenChange(false)}>
          {t("Delete Webhook")}
        </DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            {t(
              "Once deleted, this webhook will be disabled and removed from this list. "
            )}
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={() => onOpenChange(false)} testID="cancel">
            {t("Cancel")}
          </BasicButton>
          <DangerButton
            testID="delete-webhook"
            isDisabled={isDeleting}
            onPress={onRevoke}
          >
            {t("Delete webhook")}
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
